export var columnMinWidth = { minWidth: 1, width: 1 };
